export default "__VITE_ASSET__BjV0n1rf__"